<mibi-box-layout>

<form [formGroup]="resetForm" (ngSubmit)="onResetPassword()">

    <p>Bitte geben Sie ein neues Passwort ein.</p>

    <mibi-password></mibi-password>

    <div class="mibi-reset-actions">
        <a class="mibi-reset-actions__button" mat-button color="primary" [routerLink]="[userLinks.login]">
            Zurück
        </a>
        <button 
            class="mibi-reset-actions__button" 
            mat-flat-button
            color="accent"
            type="submit"
            [disabled]="!resetForm.valid"
        >
            Passwort zurücksetzen
        </button>
    </div>

</form>

</mibi-box-layout>
